import { Routes, Route } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Home from './pages/Home'
import Explore from './pages/Explore'
import Notifications from './pages/Notifications'
import Profile from './pages/Profile'
import EditProfile from './pages/EditProfile'
import Settings from './pages/Settings'
import Login from './pages/Login'
import LoginOTP from './pages/LoginOTP'
import SignUp from './pages/SignUp'
import ProfileSetup from './pages/ProfileSetupEnhanced'
import ForgotPassword from './pages/ForgotPassword'
import { MediaPreviewProvider } from './contexts/MediaPreviewContext'
import { ToastProvider } from './contexts/ToastContext'
import PostDetail from './pages/PostDetail'
import PublicPostView from './pages/PublicPostView'
import Verify from './pages/Verify'
import CreatePost from './pages/CreatePost'
import Bookmarks from './pages/Bookmarks'
import Drafts from './pages/Drafts'
import Analytics from './pages/Analytics'
// Legal pages handled by AppWrapper at top level
import AuthenticityBadgeDemo from './components/AuthenticityBadgeDemo'
import Onboarding from './pages/Onboarding'
import CreateThread from './pages/CreateThread'
import Gallery from './pages/Gallery'

// Get Google OAuth Client ID from environment
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <MediaPreviewProvider>
        <ToastProvider>
        <Routes>
          {/* Standalone Pages - No Layout, No Auth Required */}
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login-otp" element={<LoginOTP />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/profile-setup" element={<ProfileSetup />} />

          {/* Public Post View - Instagram/Twitter style: View without login */}
          <Route path="/p/:postId" element={<PublicPostView />} />
          <Route path="/posts/:postId" element={<PublicPostView />} />

          {/* Public Verification - No login required */}
          <Route path="/verify" element={<Verify />} />
          <Route path="/verify/:code" element={<Verify />} />

          {/* Legal Pages - Handled by AppWrapper (always accessible) */}
          {/* /privacy-policy, /terms-of-service, /cookie-policy, /about */}

          {/* Demo/Test Pages - No Auth Required */}
          <Route path="/demo/authenticity-badge" element={<AuthenticityBadgeDemo />} />

          {/* Protected App Pages - Require Authentication */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Home />} />
            <Route path="explore" element={<Explore />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="profile" element={<Profile />} />
            <Route path="profile/:userId" element={<Profile />} />
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="create" element={<CreatePost />} />
            <Route path="create-thread" element={<CreateThread />} />
            <Route path="bookmarks" element={<Bookmarks />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="drafts" element={<Drafts />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="post/:postId" element={<PostDetail />} />
          </Route>
        </Routes>
        </ToastProvider>
        </MediaPreviewProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  )
}

export default App
